import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { projects } from '../data/projects';
export function WorkSection() {
  return <section id="work" className="bg-ink py-24 text-ivory lg:py-32" data-id="element-219" data-mp="36i04b5ya6k5e">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-220" data-mp="36i8j53dyrzj8">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-221" data-mp="31jykgit16gsv">
          <SectionHeading eyebrow="Selected Work" tone="dark" title={<>
                Installed once. <span className="italic text-brass-light" data-id="element-223" data-mp="3u8cmd9n8px9p">Perfectly.</span>
              </>} data-id="element-222" data-mp="241xaiw1asd7" />
          <p className="max-w-sm text-sm leading-relaxed text-ivory/50" data-id="element-224" data-mp="3pab0kgyfjjuj">
            A sample of recent homes across Austin and the Hill Country — built with designers,
            cabinet makers, and homeowners who care where the screw line lands.
          </p>
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2" data-id="element-225" data-mp="28swzu26kjt1y">
          {projects.map((project, index) => <motion.li key={project.id} initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.6,
          delay: index * 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className={`group relative overflow-hidden border border-ink-600 ${index % 3 === 0 ? 'sm:col-span-2' : ''}`} data-id="element-226" data-mp="y8u40rcc7zot" data-mpi={index}>
              <img src={project.image} alt={project.title} width={1536} height={2048} loading="lazy" decoding="async" className={`w-full object-cover transition-transform duration-700 group-hover:scale-[1.03] ${index % 3 === 0 ? 'h-80 lg:h-[520px]' : 'h-80 lg:h-[420px]'}`} data-id="element-227" data-mp="jbti54gtuyy9" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" aria-hidden="true" data-id="element-228" data-mp="mei9dcvofvg" />
              <div className="absolute inset-x-0 bottom-0 flex flex-wrap items-end justify-between gap-4 p-7" data-id="element-229" data-mp="38tkuaevppxow">
                <div data-id="element-230" data-mp="33vrohmybn5p5">
                  <h3 className="font-display text-2xl text-ivory lg:text-3xl" data-id="element-231" data-mp="33t5g5l3lwm5v">{project.title}</h3>
                  <p className="mt-2 text-sm text-ivory/60" data-id="element-232" data-mp="2yu2fsdykn448">{project.detail}</p>
                </div>
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-brass-light" data-id="element-233" data-mp="c6vb8scctqc">
                  {project.location}
                </span>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}